import axios from 'axios'
import { Toast } from 'mint-ui';
import { PATH } from "./config"
import router from '../router' //引入router

// 创建axios实例\

let getCookie = function(name) {
    var strcookie = document.cookie;
    var arrcookie = strcookie.split("; ");
    for (var i = 0; i < arrcookie.length; i++) {
        var arr = arrcookie[i].split("=");
        if (arr[0] == name && arr[1] != 'undefined' && arr[1] != 'null') {
            return unescape(arr[1]);
        }
    }
    return null;
};
const service = axios.create({
        baseURL: '', // api
        timeout: 600000, // 请求超时
    })
    // request拦截器
    // 仅拦截参数配置状态响应
service.interceptors.request.use(config => {
        // config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
        // config.headers['Content-Type'] = 'multipart/form-data';
        config.headers['Content-Type'] = 'application/json'
            // config.headers['Authorization'] = 'Bearer'+' '+getCookie('token')
            // if (config.method === 'post') {
            //     if (config.type !== 'file') {
            //         config.data = qs.stringify(config.data)
            //     }
            // }
            // config.data = qs.stringify(config.data)
            // config.data = JSON.stringify(config.data)
        return config
    }, error => {
        Promise.reject(error)
    })
    // 仅拦截异常状态响应
service.interceptors.response.use(response => {
    if (response.data.code == 200 || response.data.code == '000000') {
        // if (response.data.success) {
        return response
            // } 
    } else {
        Toast({
            message: response.data.mag,
            position: 'top',
            duration: 5 * 1000
        });
        return Promise.reject(response);
    }

}, error => {
    // if (error.response.status == 401) {
    // 	Toast({
    // 		message: "登录超时",
    // 		position: 'top',
    // 		duration: 5 * 1000
    // 	});
    // 	setTimeout(() => {
    // 		router.replace({
    // 			path: 'login'
    // 		  })
    // 	}, 1500)
    // 	return Promise.reject(error.response);
    // } else if (error.response.status == 403) {
    // 	Toast({
    // 		message: "您的访问权限等级不够，请联系管理员",
    // 		position: 'top',
    // 		duration: 5 * 1000
    // 	});
    // 	return Promise.reject(error.response);
    // } else if (error.response.status == 504) {
    // 	Toast({
    // 		message: "网络超时",
    // 		position: 'top',
    // 		duration: 5 * 1000
    // 	});
    // }else if (error.response.status == 500) {
    // 	Toast({
    // 		message: "接口异常 错误代码500",
    // 		position: 'top',
    // 		duration: 5 * 1000
    // 	});
    // }else if(error.response.status == 404){
    // 	Toast({
    // 		message: "接口地址错误 错误代码404",
    // 		position: 'top',
    // 		duration: 5 * 1000
    // 	});
    // }
    return Promise.reject(error.response)
});
export default {
    //get请求
    get(params)  {        
        let  data = ""        
        Object.keys(params.data).forEach((item, index) => {             index == 0 ? data = '?' + item + '=' + params.data[item] : data = data + '&' + item + '=' + params.data[item];         })        ;
        return  new  Promise((resolve,  reject)  =>  {             service({                 method:   'get',
                //                    url: "/api" + params.url+data, //代理
                                url:  PATH + params.url + data             }).then(res  =>  {  //axios返回的是一个promise对象
                                 resolve(res)  //resolve在promise执行器内部 
                                 }).catch(err  =>  {                 reject(err)                ;
                console.log(err,  '异常')             })         })    
    },
    //post请求
    post(params) {
        return new Promise((resolve, reject) => {
            service({
                method: 'post',
                // url: "/api" + params.url, //代理
                url: PATH + params.url,
                data: params.data
            }).then(res => {
                resolve(res)
            }).catch(err => {
                reject(err)
                console.log(err, '异常')
            })
        })
    }
}